export default {
  'card.cardHolder.notValid': `Please verify the card holder`,
  'card.cardNumber.notValid': `Please verify the card number`,
  'card.month.notValid': `Please verify the month of expiration`,
  'card.year.notValid': `Please verify the year of expiration`,
  'card.cvc.notValid': `Please verify the CVC`,
  'order.card.success': 'Card paied with success',
  'order.card.error': 'Payment failed',
};
